/*
 * Copyright (C) 2019 - present Marek Kuzora - All Rights Reserved.
 */


import InfluenceEnum from 'galax/enum/new.influence';

import Collection from 'galax/util/influence/new.collection';


const SELF_INFLUENCE = 1;
const OUT_ATTRITION = 0.9;


export default class
{
  constructor (scope)
  {
    this.scope = scope;

    this.collection = new Collection();

    this.totalValue = null;
    this.currentValue = null;

    // TODO should this be needed in ctor ? Could it be set during setup maybe?
    this.currentWinner = this.scope.getUserID();

    this.currOutgoing = new Set();
    this.prevOutgoing = new Set();
  }


  install ()
  {
    this.__installSelf__(SELF_INFLUENCE);

    const { user, value } = this.__calculateWinnerWithValue__();

    this.totalValue = this.__getTotalValue__(value);
    this.currentValue = this.__getCurrentValue__(value);

    if (this.currentWinner !== user)
    {
      this.currentWinner = user;

      this.scope.getPlanet().getAttributes().setZoneWinnerChanged(true);
    }

    this.__distributeWithDirections__(value)
  }


  __calculateWinnerWithValue__ ()
  {
    let sortedTotals = this.collection.getSortedTotals();

    while (sortedTotals.length > 1)
    {
      const { user, value } = sortedTotals.shift();

      for (let entry of sortedTotals)
      {
        entry.value -= value / sortedTotals.length;
      }
    }

    return sortedTotals[0];
  }


  __getTotalValue__ (value)
  {
    return value;
  }


  __getCurrentValue__ (value)
  {
    const directions = this.scope.getDirections().getOutgoing();

    return directions.length ? 0 : value;
  }


  __distributeWithDirections__ (value)
  {
    this.prevOutgoing = this.currOutgoing;
    this.currOutgoing = new Set(this.scope.getDirections().getOutgoingZones());

    for (const oldZone of this.prevOutgoing.difference(this.currOutgoing))
    {
      oldZone.getInfluences().deleteDirection(this.scope);
    }

    for (const newZone of this.currOutgoing.difference(this.prevOutgoing))
    {
      newZone.getInfluences().addDirection(this.scope, this.currentWinner, this.__getDirectionValue__(value, this.currOutgoing.size));
    }
  }


  __getDirectionValue__ (value, count)
  {
    return value * OUT_ATTRITION / count;
  }


  addDirection (zone, user, value)
  {
    this.collection.add(zone, user, value, InfluenceEnum.Direction);
  }


  deleteDirection (zone, user, value)
  {
    this.collection.delete(zone);
  }


  __installSelf__ (value)
  {
    const user = this.scope.getUserID();

    this.collection.add(this.scope, user, value, InfluenceEnum.Default);
  }


  getOutgoingInfluenceByIndex (index)
  {
    const neighbor = this.scope.getLocation().getNeighbors().getLocationByIndex(index);

    const reverseIndex = (index + 3) % 6;

    return neighbor.getZone().getInfluences().getIncommingInfluenceByIndex(reverseIndex);
  }


  getIncommingInfluenceByIndex (index)
  {
    const neighbor = this.scope.getLocation().getNeighbors().getLocationByIndex(index);

    const influence = this.collection.getBySource(neighbor);

    return influence ? influence : { user: neighbor.getUser().getID(), value: null };
  }


  getWinner ()
  {
    return this.currentWinner;
  }


};
